import React from 'react';
import FaqItem from './FaqItem';
import { FaQuestionCircle, FaInfoCircle, FaCommentDots } from 'react-icons/fa';

const faqData = [
  {
    question: 'Frequently asked questions',
    answer: 'Here are some of the most frequently asked questions about our service...',
    icon: <FaQuestionCircle />
  },
  {
    question: 'Terms of Service',
    answer: 'By using our service, you agree to our terms and conditions.',
    icon: <FaInfoCircle />
  },
  {
    question: 'Need help? Chat with us',
    answer: 'Click the chat icon on the bottom right to connect with our support team.',
    icon: <FaCommentDots />
  }
];

const FaqSection = () => {
  return (
    <div className="faq-section">
      {faqData.map((faq, idx) => (
        <FaqItem key={idx} {...faq} />
      ))}
    </div>
  );
};

export default FaqSection;
